import { TumbleDryerIcon } from './TumbleDryerIcon';

/**
 * author: GreenTurtwig
 * id 7796F195-34DA-4CAA-8F58-1179343EFB18
 * name tumble-dryer
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tumble-dryer.svg
 * tags
 * - Home Automation 
 */
export const LaundryRoomIcon = TumbleDryerIcon;
export default LaundryRoomIcon